module.exports = global["dayjs"] = require("-!./dayjs.min.js");